import { Typography } from '@mui/material';
import Grid from 'components/core/Grid';
import { listGuidebookGuestImage } from 'config/imageUrls';

import { ContentSection, StyledBulletList, DividerTemp } from './styles';

export const CheckinGuidebook = () => {
  return (
    <>
      <ContentSection>
        <Grid container spacing={4}>
          <Grid item xs={12} md={7}>
            <Typography variant="h2" mb={2}>
              Guest Check-In &amp; Property Guidebook
            </Typography>
            <Typography mb={2}>
              Before guests can fully enjoy and experience your property, they need to know what is provided, where to
              park and how to physically get into the property. alluraDirect automates and makes this consistent.
            </Typography>
            <Typography>
              <strong>Automatic and Secure Delivery of Information.</strong>
            </Typography>
            <StyledBulletList>
              <li>Multiple delivery methods ensure every guest receives what they need.</li>
              <li>Instructions are sent by email, PDF and the mobile app.</li>
              <li>Maintain security by sending codes and check-in details on the arrival day.</li>
            </StyledBulletList>
            <Typography>
              <strong>Property Guidebooks Ensure a Stress-Free Vacation.</strong>
            </Typography>
            <StyledBulletList>
              <li>Reduce questions and requests with a great property guidebook.</li>
              <li>Provide a better experience for your guests with more information.</li>
              <li>Automatically answers most of the common questions before arrival.</li>
            </StyledBulletList>
          </Grid>
          <Grid item xs={12} md={5} align="center">
            <img
              src={listGuidebookGuestImage}
              width="100%"
              style={{ maxWidth: '400px' }}
              className="add-image-shadow"
            />
          </Grid>
        </Grid>
      </ContentSection>

      <ContentSection>
        <DividerTemp />
      </ContentSection>
    </>
  );
};
